export default __webpack_public_path__ + "static/media/cms.a578d06c.gif";